import IconWord from '@/assets/images/fileIcon/word.svg';
import IconExcel from '@/assets/images/fileIcon/excel.svg';
import IconPpt from '@/assets/images/fileIcon/ppt.svg';
import IconPdf from '@/assets/images/fileIcon/pdf.svg';
import IconTxt from '@/assets/images/fileIcon/txt.svg';

import IconFolder from '@/assets/images/fileIcon/folder.svg';
import IconZip from '@/assets/images/fileIcon/zip.svg';

import IconAudio from '@/assets/images/fileIcon/audio.svg';
import IconVideo from '@/assets/images/fileIcon/video.svg';
import IconImage from '@/assets/images/fileIcon/image.svg';

import IconUnknown from '@/assets/images/fileIcon/unknown.svg';

import { Doc, DocTypeEnum } from '@/types/doc';
import { downloadFileUrl, downloadFileUrlBatch, getFileUrl } from '@/apis/file';

export const word = ['doc', 'docx', 'docm', 'dot'];
export const txt = ['txt'];
export const excel = ['xlsx', 'xlsm', 'xlsb', 'xltx', 'xltm', 'xls', 'xlt', 'xml', 'xlam', 'xla', 'xlw', 'xlr'];
export const ppt = ['pptx', 'pptm', 'ppt', 'pot', 'ppsx', 'ppsm', 'pps', 'ppa'];
export const pdf = ['pdf'];
export const html = ['htm', 'html'];
export const audio = [
	'3gp',
	'aa',
	'aac',
	'aax',
	'act',
	'aiff',
	'alac',
	'amr',
	'ape',
	'au',
	'awb',
	'dct',
	'dss',
	'dvf',
	'flac',
	'gsm',
	'iklax',
	'ivs',
	'm4a',
	'm4b',
	'm4p',
	'mmf',
	'mp3',
	'mpc',
	'msv',
	'nmf',
	'nsf',
	'ogg',
	'oga',
	'mogg',
	'opus',
	'ra',
	'rm',
	'raw',
	'sln',
	'tta',
	'voc',
	'vox',
	'wav',
	'wma',
	'wv',
	'8svx',
	'cda',
];
export const video = [
	'webm',
	'mkv',
	'flv',
	'vob',
	'ogv',
	'drc',
	'mng',
	'avi',
	'MTS',
	'M2TS',
	'TS',
	'mov',
	'qt',
	'wmv',
	'yuv',
	'rm',
	'rmvb',
	'asf',
	'amv',
	'mp4',
	'm4p',
	'm4v',
	'mpg',
	'mp2',
	'mpeg',
	'mpe',
	'mpv',
	'mpg',
	'm2v',
	'm4v',
	'svi',
	'3g2',
	'mxf',
	'roq',
	'nsv',
	'f4v ',
	'f4p ',
	'f4a ',
	'f4b',
];
export const image = [
	'bmp',
	'gif',
	'jpe',
	'jpeg',
	'jpg',
	'ico',
	'png',
	'apng',
	'webp',
];
export const zip = ['iso', 'tar', 'gz', 'xz', '7z', 'rar', 'tgz', 'bz2', 'zip', 'zipx'];

export const getFileIcon: (name: string, type?: DocTypeEnum) => string = (name, type) => {
  if (type === DocTypeEnum.NODE) return IconFolder;
	name = name?.toLowerCase();
	const nameArr = name?.split('.');
	const suffix = nameArr[nameArr.length - 1];

  if (word.includes(suffix)) return IconWord;
  if (excel.includes(suffix)) return IconExcel;
  if (ppt.includes(suffix)) return IconPpt;
  if (pdf.includes(suffix)) return IconPdf;
  if (txt.includes(suffix)) return IconTxt;
  if (audio.includes(suffix)) return IconAudio;
  if (video.includes(suffix)) return IconVideo;
  if (image.includes(suffix)) return IconImage;
  if (zip.includes(suffix)) return IconZip;

  return IconUnknown;
}

export const downloadFile = (fileId: string) => {
	window.open(downloadFileUrl(fileId), '_self');
};

export const downloadFileBatch = (fileIds: string[]) => {
	window.open(downloadFileUrlBatch(fileIds), '_self');
};

export const handlePreviewFile = (file: Pick<Doc, 'fileId' | 'suffix'>) => {
	if (file.fileId) {
		const suffix = file.suffix?.toLowerCase();
		const previewableTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'pdf', 'txt', 'json', 'xml', 'html', 'htm'];

		if (suffix && previewableTypes.includes(suffix)) {
			const fileUrl = getFileUrl(file.fileId);
			if (fileUrl) {
				window.open(fileUrl, '_blank');
			}
		} else {
			downloadFile(file.fileId);
		}
	}
};
